<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSupplierPricelists.title") }}
      <v-btn
          color="success"
          class="ml-1 green-shadow"
          x-small
          fab
          max-width="26"
          max-height="26"
          :to="{ name: 'pricelists-create' }"
          :title="$t('common.add')"
          :disabled="!fetched"
          :loading="!fetched"
      >
        <v-icon x-small>$plus</v-icon>
      </v-btn>
    </h3>
    <v-toolbar elevation="0" dense rounded class="mt-3">
      <v-toolbar-items>
        <v-btn small text :to="{name:'suppliers'}" exact>{{ $t('viewSuppliers.title') }}</v-btn>
        <v-btn small text :to="{name:'pricelists'}"> {{ $t("viewSupplierPricelists.title") }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-data-table
      :headers="pricelistsTableHeader"
      :items="pricelists"
      class="elevation-0 mb-3"
    >
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left">{{ props.item.human_number }}</td>
          <td class="text-xs-left">
            {{ props.item.supplier && props.item.supplier.name }}
            <v-icon
              small
              color="red"
              v-if="props.item.supplier && props.item.supplier.is_enabled_search_by_pricelists != 1"
              :title="
                $t('viewSupplierPricelists.supplier_is_disabled', [
                  props.item.supplier && props.item.supplier.name,
                ])
              "
              >fa-exclamation-triangle</v-icon
            >
          </td>
          <td class="text-xs-left text-no-wrap">
            <input
              v-show="false"
              :ref="'replaceFileInput' + props.item.id"
              type="file"
              @change="replaceFile(props.item.id)"
              :accept="'.' + props.item.type"
            />
            <v-icon
              class="mr-2"
              small
              @click="$refs['replaceFileInput' + props.item.id].click()"
              >fa-file-upload</v-icon
            >
            <a :download="props.item.name" :href="'/platform' + props.item.path"
              ><v-icon class="mr-2" small>fa-file-download</v-icon></a
            >
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            {{ props.item.created_at | moment("DD.MM.YYYY") }}
            <br/>
            {{ props.item.created_at | moment("HH:mm") }}
          </td>
          <td class="text-xs-left">{{ props.item.updated_at }}</td>
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td class="text-xs-left">
            {{ props.item.processed }} / {{ props.item.successfully_processed }}
          </td>
          <td class="text-xs-left">{{ props.item.delivery }}</td>
          <td class="text-xs-center text-no-wrap">
            <v-icon
              :title="getStatusTitle(props.item.status)"
              @click="changeStatus(props.item)"
              :class="{
                pointer: props.item.status === 1 || props.item.status === 0,
              }"
              :color="getStatusIcon(props.item.status).color"
              >{{ getStatusIcon(props.item.status).icon }}
            </v-icon>
            <span class="pl-2" v-if="props.item.progress < 100"
              >{{ props.item.progress }}%</span
            >
          </td>
          <td class="text-xs-left text-no-wrap">
            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              color="primary"
              class="mb-0 ml-3 px-0 white--text"
              :to="{ name: 'pricelist', params: { id: props.item.id } }"
              :title="$t('common.edit')"
            >
              <v-icon small>$pencil</v-icon>
            </v-btn>

            <v-btn
              elevation="0"
              min-width="36"
              min-height="36"
              :disabled="props.item.id < 0"
              @click="
                $store.dispatch('pricelists/pricelistRemove', {
                  id: props.item.id,
                })
              "
              color="red lighten-2"
              class="mb-0 ml-3 px-0 white--text"
              :title="$t('common.remove')"
            >
              <v-icon small>$trash</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
export default {
  data: () => ({}),
  mounted() {
    this.$store.dispatch("pricelists/pricelistsGet");
  },
  computed: {
    ...mapFields("pricelists", ["pricelists", "fetched"]),
    pricelistsTableHeader() {
      return [
        {
          text: this.$t(
            "viewSupplierPricelists.pricelistsTableHeader.human_number"
          ),
          value: "human_number",
          sortable: true,
        },
        {
          text: this.$t("common.supplier"),
          value: "supplier.name",
          sortable: true,
        },
        {
          text: this.$t(
            "viewSupplierPricelists.pricelistsTableHeader.name"
          ),
          value: "name",
          sortable: true,
        },
        {
          text: this.$t(
            "viewSupplierPricelists.pricelistsTableHeader.created_at"
          ),
          value: "created_at",
          sortable: true,
        },
        {
          text: this.$t(
            "viewSupplierPricelists.pricelistsTableHeader.updated_at"
          ),
          value: "updated_at",
          sortable: true,
        },
        {
          text: this.$t(
            "viewSupplierPricelists.pricelistsTableHeader.type"
          ),
          value: "type",
          sortable: true,
        },
        {
          text: this.$t(
            "viewSupplierPricelists.pricelistsTableHeader.processed"
          ),
          value: "processed",
          sortable: true,
        },
        {
          text: this.$t(
            "viewSupplierPricelists.pricelistsTableHeader.delivery"
          ),
          value: "delivery",
          sortable: true,
        },
        {
          text: this.$t(
            "viewSupplierPricelists.pricelistsTableHeader.status"
          ),
          value: "status",
          sortable: true,
        },
        { text: this.$t("common.actions"), sortable: false },
      ];
    },
  },
  methods: {
    changeStatus(item) {
      item.status = null;
      this.$store
        .dispatch("pricelists/pricelistChangeStatus", { id: item.id })
        .then((status) => {
          item.status = status;
        });
    },
    replaceFile(id) {
      let file = this.$refs["replaceFileInput" + id].files[0];
      let extension = this.pricelists.find(
        (pricelist) => pricelist.id === id
      ).type;
      if (file.name.split(".").pop() != extension) {
        this.$error(
          this.$t("viewSupplierPricelists.wrong_file_type", [extension])
        );
      } else {
        this.$store.dispatch("pricelists/replaceFile", { file, id });
      }
      this.$refs["replaceFileInput" + id].value = "";
    },
    getStatusTitle(status) {
      switch (status) {
        case 1:
          return this.$t("viewSupplierPricelists.active");
          break;
        case 0:
          return this.$t("viewSupplierPricelists.disabled");
          break;
        default:
          return "";
          break;
      }
    },
    getStatusIcon(status) {
      switch (status) {
        case 1:
          return { icon: "fas fa-check", color: "success" };
          break;
        case 0:
          return { icon: "fas fa-times", color: "warning" };
          break;
        default:
          return { icon: "fas fa-circle-notch fa-spin", color: "accent" };
          break;
      }
    },
  },
};
</script>
